import { lineItemGroups, paymentAmountOptions, rateCategoryOptions, subcategories } from '../../../../../configured-components/form/configured-inputs/special/payment-line-item-rates/select-options';
import Region from '../../../../../constants/region';
import { getReadableNameFromOptions } from './utils';

export const defaultLineItemRatesTableColumns = [
    { field: 'rate_name', headerName: 'Name', minWidth: 200, flex: 1 },
    { field: 'description', headerName: 'Description', minWidth: 200, flex: 1 },
    { field: 'subcategory', headerName: 'Type', minWidth: 200, valueFormatter: ({ value }) => getReadableNameFromOptions(subcategories, value) },
    { field: 'paid_by_payer', headerName: 'Paid By Payer', minWidth: 120, valueFormatter: ({ value }) => (value ? 'Yes' : 'No') },
    { field: 'paid_to_payee', headerName: 'Paid To Payee', minWidth: 150, valueFormatter: ({ value }) => getReadableNameFromOptions(paymentAmountOptions, value) },
    { field: 'payer_category', headerName: 'Payer Category', minWidth: 150, valueFormatter: ({ value }) => getReadableNameFromOptions(rateCategoryOptions, value) },
    { field: 'payee_category', headerName: 'Payee Category', minWidth: 150, valueFormatter: ({ value }) => getReadableNameFromOptions(rateCategoryOptions, value) },
    { field: 'line_item_group', headerName: 'Line Item Group', minWidth: 150, valueFormatter: ({ value }) => getReadableNameFromOptions(lineItemGroups, value) },
    { field: 'gl_number', headerName: 'GL Number', minWidth: 150 },
    { field: 'account', headerName: 'Account', minWidth: 150 },
    { field: 'reference', headerName: 'Reference', minWidth: 150 },
];

export const lineItemRatesTableColumnsMap = {
    [Region.UNC]: defaultLineItemRatesTableColumns,
    [Region.BONGARDS]: defaultLineItemRatesTableColumns,
    [Region.DEMO]: defaultLineItemRatesTableColumns,
};
